import { render } from "./EventPrc9.vue?vue&type=template&id=0fb4f3ba"
import script from "./EventPrc9.vue?vue&type=script&lang=js"
export * from "./EventPrc9.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__